module.exports = __webpack_public_path__ + "static/media/VIN_ng.95f62e59.png";